import fetch from '../util/fetch';

// 取得 Server Version
export function getApiServerVersion() {
	return fetch({
		url: '/cars/server/info',
		method: 'get',
	});
}
